// extracted by mini-css-extract-plugin
module.exports = {"footer-btns":"footer-buttons_footer-btns__TbJvD","footer-btns-spacer":"footer-buttons_footer-btns-spacer__K8Wu4"};